// import { RoutesMappings } from "constants/list"
import dayjs from "dayjs"
import { dateTimeFunction } from "./date"

export const getLinkParamDateRange = (params, key) => {
  const currentDate = dayjs().format("YYYY-MM-DD 23:59:59")
  const startDate = dayjs().subtract(6, "days").format("YYYY-MM-DD 00:00:00")
  const toDate = params?.toDate || currentDate
  const fromDate = params?.fromDate || startDate
  if (key) {
    return `${key}=${encodeURIComponent(
      dateTimeFunction({
        date: decodeURIComponent(fromDate),
        timeZone: true,
        apiRequest: true,
      })
    )},${encodeURIComponent(
      dateTimeFunction({
        date: decodeURIComponent(toDate),
        timeZone: true,
        apiRequest: true,
      })
    )}`
  } else {
    return `fromDate=${encodeURIComponent(
      dateTimeFunction({
        date: decodeURIComponent(fromDate),
        timeZone: true,
        apiRequest: true,
      })
    )}&toDate=${encodeURIComponent(
      dateTimeFunction({
        date: decodeURIComponent(toDate),
        timeZone: true,
        apiRequest: true,
      })
    )}`
  }
}

export const getURLString = (dynamicFilters, params, filtersObj, parent, key) => {
  if (filtersObj?.filters) {
    let path = `${RoutesMappings[filtersObj?.module]}?`
    filtersObj.filters.forEach(e => {
      if (e.includes("_")) {
        const parts = e.split("_")
        if (filtersObj?.module == "calls" && parts[1] === "daterange") {
          path = path + getLinkParamDateRange(params)
        } else if (parts[1] === "daterange") {
          path = path + getLinkParamDateRange(params, parts[0])
        }
      } else if (!!dynamicFilters?.[parent]?.[key]?.[e]) {
        path = path + `&${e}=${dynamicFilters[parent][key][e]}`
      }
    })
    return path
  }
  return null
}
export const getUserMappingKey = filtersObj => {
  let userKey = ""
  filtersObj?.filters?.forEach(e => {
    if (e.includes("_")) {
      const parts = e.split("_")
      if (parts[1] === "user") {
        userKey = parts[0]
      }
    }
  })
  return userKey
}

export const truncateText = (text, maxLength = 0) => {
  return text?.length > maxLength ? text?.slice(0, maxLength - 3) + "..." : text || ""
}
